import axiosInstance from "../config/axios.js"

const API_BASE = "/dry-box-files"

const fileCabinetService = {
  // Upload single or multiple files
  uploadFiles: async (surveyId, clientId, files) => {
    const formData = new FormData()
    formData.append("survey_id", surveyId)
    formData.append("client_id", clientId)

    files.forEach((file) => {
      formData.append("files", file)
    })

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },

  // Get all files for a survey
  getFilesBySurveyId: async (surveyId) => {
    const response = await axiosInstance.get(API_BASE, {
      params: { survey_id: surveyId },
    })
    return response.data
  },

  // Get single file by ID
  getFileById: async (fileId) => {
    const response = await axiosInstance.get(`${API_BASE}/${fileId}`)
    return response.data
  },

  // Delete single file
  deleteFile: async (fileId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${fileId}`)
    return response.data
  },

  // Delete multiple files
  deleteMultipleFiles: async (fileIds) => {
    const response = await axiosInstance.delete(`${API_BASE}/delete-multiple`, {
      data: { file_ids: fileIds },
    })
    return response.data
  },

  // Download single file
  downloadFile: async (fileId) => {
    const response = await axiosInstance.get(`${API_BASE}/${fileId}/download`, {
      responseType: "blob",
    })
    return response.data
  },

  // Download multiple files as ZIP
  downloadMultipleFiles: async (fileIds) => {
    const fileIdParams = fileIds.map((id) => `file_ids=${id}`).join("&")
    const response = await axiosInstance.get(`${API_BASE}/download-multiple?${fileIdParams}`, {
      responseType: "blob",
    })
    return response.data
  },

  // Download all files for a survey as ZIP
  downloadBySurvey: async (surveyId) => {
    const response = await axiosInstance.get(`${API_BASE}/download-by-survey`, {
      params: { survey_id: surveyId },
      responseType: "blob",
    })
    return response.data
  },

  // Download entire cabinet as ZIP
  downloadAllCabinet: async () => {
    const response = await axiosInstance.get(`${API_BASE}/download-all-cabinet`, {
      responseType: "blob",
    })
    return response.data
  },
}

export default fileCabinetService